import axios from 'axios';
import { X } from './request'
import { store } from './store.js';

let xReady = null;

// Call this once at startup to ensure Xchanne is fetched before any API calls
export function initX() {
  if (xReady) return xReady;
  xReady = axios
    .get(`${process.env.VUE_APP_VIDEO3_API_URL}/api/index/config`)
    .then((res) => {
      X.Xchanne = res.headers['x-debug-channel'] || '';
      // 复用该请求结果，预热全局配置，避免后续再次请求 config
      if (res.data) {
        try {
          store.setConfig(res.data);
          store.markConfigInitial();
        } catch (e) { }
      }
      return X;
    })
    .catch(() => {
      X.Xchanne = '';
      return X;
    });
  return xReady;
}

export function waitForX() {
  return xReady || Promise.resolve(X);
}

export { X };
export default X;
